import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ProductsProvider } from "./context/products_context";
import { FilterProvider } from "./context/filter_context";
import { CartProvider } from "./context/cart_context";

const tree = (
  <ProductsProvider>
    <FilterProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </FilterProvider>
  </ProductsProvider>
);

const rootElement = document.getElementById("root");

// react-snap prerenders HTML at build time and writes it into the root.
// In the browser: if root holds prerendered markup, hydrate it; the static
// splash loader from index.html doesn't count — replace it with a fresh render.
const isSplashOnly = document.getElementById("initial-loader") !== null;

if (rootElement.hasChildNodes() && !isSplashOnly) {
  hydrateRoot(rootElement, tree);
} else {
  rootElement.innerHTML = "";
  createRoot(rootElement).render(tree);
}
